{
    "OnavailablestateLabel": "Op Beschikbare Staat Over:",
    "OnbusystateLabel": "Bij Bezet Over:",
    "OnnaordndstateLabel": "Aan N.v.t. of Niet storen Toestand voorbij:",
    "OnwrapupLabel": "Op Wrap-Up Status Over:",
    "OnavailablestateEnabledHiddenlabel": "Is Aan Beschikbare Staat Over Instelling ingeschakeld?",
    "OnbusystateEnabledHiddenlabel": "Is Aan Bezet Status Over Instelling ingeschakeld?",
    "OnnaordndstateEnabledHiddenlabel": "Is Aan N.v.t. of Niet storen Status Over Instelling ingeschakeld?",
    "OnwrapupEnabledHiddenlabel": "Is de instelling Op Wrap-Up State Over ingeschakeld?",
    "OnavailablestatePlaceholder": "jaren '30",
    "OnbusystatePlaceholder": "5m 0s",
    "OnnaordndstatePlaceholder": "3m 0s",
    "OnwrapupPlaceholder": "3m 0s",
    "ACDStateThresholds_SectionHeader": "Drempelwaarden ACD-status",
    "ACDStateThresholds_SectionPara": "Je kunt alarmen activeren wanneer agents te lang in een bepaalde ACD-status blijven. Kies hieronder de ACD toestanden die een alarm zullen activeren en kies dan de gewenste activeringsduur.",
    "NAME": "ACDStateThresholds"
}